export default "__VITE_ASSET__4OYTb8HZ__"